// Forms/Field.js

import React from "react";

export const Field = ({ children, label, error, className = '' }) => {
    const id = getChildId(children);

    return (
        <div className={"form__field " + className}>
            {children}
            <label htmlFor={id}>{label}</label>
            {error && <small className="error">{error.message}</small>}
        </div>
    );
};

// Get id prop from a child element
export const getChildId = (children) => {
    const child = React.Children.only(children);

    if ("id" in child?.props) {
        return child.props.id;
    }
};
